import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";

import { LayoutService } from "./layout.service";
import { MyCookieService } from "../core/services/cookie.service";
import { AuthGuardService } from "../core/services/auth-guard.service";

import { CommonsModule } from "../commons/commons.module";

import { LayoutComponent } from "./layout.component";
import { routes as kh24Routes } from "src/app/tenants/kh24/kh24.module";
import { routes as kh24betaRoutes } from "src/app/tenants/kh24-beta/kh24-beta.module";
import { routes as estradiRoutes } from "src/app/tenants/estradi/estradi.module";
import { routes as olutmaailmaRoutes } from "src/app/tenants/olutmaailma/olutmaailma.module";
import { routes as jaloviiniRoutes } from "src/app/tenants/jaloviini/jaloviini.module";

import { tenant } from "site-config";

export const routes: Routes = [
  {
    path: "",
    loadChildren: () => import("./home/home.module").then((m) => m.HomeModule),
  },
  {
    path: "dashboard",
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
  },
  {
    path: "p",
    loadChildren: () =>
      import("./product/product.module").then((m) => m.ProductModule),
  },
  {
    path: "cart",
    loadChildren: () => import("./cart/cart.module").then((m) => m.CartModule),
  },
  {
    path: "recipes",
    loadChildren: () =>
      import("./recipe/recipe.module").then((m) => m.RecipeModule),
  },
  {
    path: "vendor",
    loadChildren: () =>
      import("./vendor/vendor.module").then((m) => m.VendorModule),
  },
  {
    path: "",
    children:
      (tenant === "kh24" && kh24Routes) ||
      (tenant === "kh24-beta" && kh24betaRoutes) ||
      (tenant === "estradi" && estradiRoutes) ||
      (tenant === "olutmaailma" && olutmaailmaRoutes) ||
      (tenant === "jaloviini" && jaloviiniRoutes),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), CommonModule, CommonsModule],
  exports: [LayoutComponent],
  providers: [LayoutService, MyCookieService],
  declarations: [LayoutComponent],
})
export class LayoutModule {}
